/**
 * EngineMode enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file EngineMode.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum EngineMode {
  LOADING   = -1,
  GUI       =  0,
  INGAME    =  1,
  MINIGAME  =  2,
  DIALOG    =  3,
  FREELOOK  =  4,
  MOVIE     =  5,
  LEGAL     =  6,
}